import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldCheck, ChevronRight } from 'lucide-react';
import { safetyMaterialsCategories } from '../data/safetyMaterialsCategories';
import { getCategoryItemCount } from '../data/safetyMaterialsItems';

const MaterialsHubSidebar = ({ isSearchBarVisible = true }) => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div
      className="w-80 bg-white border-r border-gray-200 overflow-y-auto transition-all duration-500 ease-in-out"
      style={{ marginTop: isSearchBarVisible ? '130px' : '80px' }}
    >
      <div className="pt-4 pb-4 px-2 sm:px-4">
        <h3 className="text-sm font-bold text-gray-600 px-2 mb-4">
          분야별 안내
        </h3>
        <nav className="space-y-1">
          {safetyMaterialsCategories.map((cat) => {
            const isPpe = cat.id === 'ppe';
            const active =
              (isPpe && pathname.startsWith('/safety-materials/ppe')) ||
              pathname === cat.path;
            const itemCount = cat.id === 'ppe' ? null : getCategoryItemCount(cat.id);
            const subtitleLine =
              itemCount != null ? `${itemCount}개 물품` : cat.subtitle;

            const inner = (
              <>
                <span className="flex-1 text-left min-w-0">
                  <span className="block font-medium truncate">{cat.title}</span>
                  {subtitleLine && (
                    <span className="block text-sm text-gray-500 mt-0.5 truncate">{subtitleLine}</span>
                  )}
                </span>
                <ChevronRight size={16} className="shrink-0 text-gray-400" />
              </>
            );

            const className = `w-full flex items-center gap-2 px-4 py-3.5 rounded-xl text-base transition-colors ${
              active
                ? 'bg-green-50 text-green-900 border border-green-200'
                : 'text-gray-700 hover:bg-gray-50 border border-transparent'
            }`;

            return (
              <Link key={cat.id} to={cat.path} className={className}>
                {isPpe && <ShieldCheck size={18} className="shrink-0 text-green-600" />}
                {inner}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default MaterialsHubSidebar;
